export default __webpack_public_path__ + "static/media/step_icon_3.4b4ff356.png";